import { t } from "@/i18n-js/instance";
import { formatPaywallCurrencyAmount } from "@/react/helpers/paywalls/currencies";
import { mapCurrencyAmountStrToInt } from "@circle-react/components/Paywalls/Admin/utils";
import { paywallPriceTypes } from "@circle-react/types/PaywallPrice";
import type {
  NoticeScenario,
  NoticeScenarioMatcher,
  NoticeScenarioMessagePropsResolver,
} from "../NoticeScenario.types";
import { localeRoot } from "../constants";
import { onetimeStateValidator } from "./StateValidators";

const matcher: NoticeScenarioMatcher = ({ priceType }) =>
  priceType === paywallPriceTypes.onetime;

const messagePropsResolver: NoticeScenarioMessagePropsResolver = ({
  currency,
  watch,
}) => [
  ["onetime"],
  {
    member_charged_immediately_phrase: t(
      [localeRoot, "phrases", "member_charged_immediately"],
      {
        amount: formatPaywallCurrencyAmount(
          currency,
          mapCurrencyAmountStrToInt(watch("amount")),
        ),
      },
    ),
  },
];

export const onetime: NoticeScenario = {
  matcher,
  stateValidator: onetimeStateValidator,
  messagePropsResolver,
};
